/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import { UnloadedQuery } from '../Tables/Filter';
import { computeWeights } from '@/utils/query';
import { crudRequestGet } from '@/services/api';
import { dateDiffCalculation } from '@/utils/date';
import { find } from 'lodash';
import { getData_Vehicle2 } from '@/components/report/service';
import moment from 'moment';
import { recombinationData } from '@/utils';

const params = {};

export default {
  namespace: 'unloadedtableNew',
  state: {
    unloadedList: [], // 待卸
  },

  effects: {
    *getArrivalCarData({ paylaod }, { select, put, call }) {
      const { actualArrivalCarsItem, dateRange, centerFilter } = yield select(
        ({ vehicleMonitoringNew }) => vehicleMonitoringNew,
      );
      // const taskNos = actualArrivalCarsItem.filter(m => m.dockModel !== '往返').map(m => m.taskNo)
      const taskNos = actualArrivalCarsItem.map((m) => m.taskNo);
      // 带入TMS实际已到运输凭单号查询,上一站到本站的装车数据 = 本站已到
      // 从本站已到中过滤掉 本站已卸数据,就是待卸
      const param = {
        scanSiteCode: centerFilter.code,
        scanSite: centerFilter.name,
        startDate: dateRange[0],
        endDate: dateRange[1],
        taskNos,
      };
      const [unLoadDataFlilter, productDataFilter, _, scanUnLoadDataFilter, unLoadDataFlilterDRNo] =
        UnloadedQuery(param);

      /** 上一站到本站的装车, 定时达 , 车辆已装货量*/
      const [unLoadData, productData, unLoadDataDrNo] = yield Promise.all([
        getData_Vehicle2(unLoadDataFlilter, {}, 'druid2'),
        getData_Vehicle2(productDataFilter, {}, 'druid2'),
        getData_Vehicle2(unLoadDataFlilterDRNo, {}, 'druid2'),
      ]);
      const deliveryReceiptNoArr = unLoadDataDrNo.map((item) => item.deliveryReceiptNo);
      const deliveryData = [];
      const preeCount = 40; // 每次请求交接单信息条数
      for (let first = 0; first < deliveryReceiptNoArr.length; first += preeCount) {
        let last = first + preeCount;
        if (last > deliveryReceiptNoArr.length) last = deliveryReceiptNoArr.length;
        const deliverList = deliveryReceiptNoArr.slice(first, last);
        const result = yield crudRequestGet(
          // 获取交接单信息集
          `/api/v1/track/receipt/infoDetail?deliveryNoList=${deliverList}`,
          { module: 'maxcenterbusi' },
        );
        if (result && result?.data?.length > 0) {
          deliveryData.push(...result?.data);
        }
      }

      let dataList = [];
      for (let i = 0; i < unLoadData.length; i++) {
        const item = unLoadData[i];
        if (item.calcWeight == 0) {
          continue;
        }

        const finds = actualArrivalCarsItem.find((m) => m.taskNo === item.taskNo);
        let status = '';
        let dateDiff = null;
        const planTime = moment(finds.planTime).valueOf();
        const actualTime = moment(finds.actualTime).valueOf();
        if (actualTime > planTime) {
          status = '延误';
          dateDiff = dateDiffCalculation(actualTime, planTime);
        } else if (actualTime < planTime) {
          status = '提前';
          dateDiff = dateDiffCalculation(planTime, actualTime);
        } else {
          status = '准点到达';
        }

        // 押车时长 当前时间 - 实际到达时间
        const escortTime = dateDiffCalculation(new Date(), finds.actualTime);
        // 过滤掉已卸载的数据  不使用此条件判断
        // const unloadDataMatch = scanUnLoadData.find((sunload) => sunload.taskNo === item.taskNo);
        // 天象取已卸时间
        const deliveryDataMatch = deliveryData.filter(
          (delivery) => delivery.taskNo === item.taskNo,
        );
        console.log(deliveryDataMatch);
        let isUnload = false;
        deliveryDataMatch?.map((item) => {
          if (!isUnload) {
            isUnload = !!item.arriveBeginTime || !!item.arriveEndTime;
          }
        });
        if (!isUnload) {
          const product = productData.find((product) => item.taskNo === product.taskNo);
          dataList.push({
            ...finds,
            calcWeight0: computeWeights(Number(item.calcWeight)),
            unloadVolume0: Math.abs(Number(item.goodsVolume).toFixed(1)),
            calcWeight1: computeWeights(Number(product?.calcWeight)),
            ticket1: Math.abs(Number(product?.ticket)) || 0,
            // top: topNextSite.toString(),
            delayTime: `${status}: ${dateDiff.formatDate}`,
            escortTime: escortTime.formatDate,
            escortSeconds: escortTime.secondCount,
            key: i,
          });
        }
      }

      //#region top3获取
      /** 用于统计下一站top3数据,单独查询 更少的运输凭单号，查询更快 */
      const topsResults = yield getData_Vehicle2(
        UnloadedQuery({ ...param, taskNos: dataList.map((m) => m.taskNo) })[2],
        {},
        'druid2',
      );

      let siteCityTops = yield getData_Vehicle2(
        UnloadedQuery({ ...param, taskNos: dataList.map((m) => m.taskNo) })[5],
        {},
        'druid2',
      );

      let currentCenterName = centerFilter?.name;
      if (siteCityTops.length > 0) {
        siteCityTops = siteCityTops.filter((item) => {
          const routePaths = item.routePath ? item.routePath?.split('-') : null;
          return routePaths?.lastItem === currentCenterName;
        });
      }
      const siteCityTopsDic = recombinationData(siteCityTops, 'taskNo');
      siteCityTopsDic?.forEach((item) => {
        let allCity = item.child;
        let calcWeightSum = allCity?.reduce(
          (pre, curr) => Math.abs(Number(curr?.ticket)) + Number(pre),
          0,
        );
        let destinationSiteData = recombinationData(allCity, 'destinationCity');
        destinationSiteData?.forEach((city) => {
          city.currentCityCalcWeightSum = city?.child.reduce(
            (pre, curr) => Math.abs(Number(curr?.ticket)) + pre,
            0,
          );
          city.calcWeightSum = calcWeightSum;
        });
        destinationSiteData = destinationSiteData?.sort(
          (a, b) =>
            (b?.currentCityCalcWeightSum || 0) - (a?.currentCityCalcWeightSum || 0) ||
            String(a.destinationCity).localeCompare(String(b.destinationCity)),
        );
        item.destinationSiteData = destinationSiteData;
      });

      let taskNoTops = [];
      // const site = centerFilter.replace('分拨中心', '');
      if (topsResults.length > 0) {
        const newsTopsResults = [];
        topsResults.forEach((item) => {
          // const reg = new RegExp(`${site}-(.*)`)
          const routePaths = item.routePath?.split('-') || [];
          const routePath = routePaths.length >= 3 ? routePaths[2] : null;
          if (routePath) {
            newsTopsResults.push({ ...item, routePath });
          }
        });
        taskNoTops = recombinationData(newsTopsResults, 'taskNo');
      }
      dataList = dataList.map((item) => {
        const topNextSite = [];
        taskNoTops.forEach(({ taskNo, child }) => {
          if (taskNo === item.taskNo) {
            // 并列时按站点名兜底,保证同一份数据多次排序结果一致
            const childs = child.sort(
              (a, b) =>
                Math.abs(b.calcWeight) - Math.abs(a.calcWeight) ||
                String(a.routePath).localeCompare(String(b.routePath)),
            );
            for (let j = 0; j < childs.length && j < 3; j++) {
              topNextSite.push(childs[j].routePath.replace('分拨中心', ''));
            }
          }
        });

        // 处理到达时间字段actualTime
        const actualTime = item.actualTime ? moment(item.actualTime) : null;

        const siteCityObj = siteCityTopsDic.find((city) => city.taskNo === item.taskNo);

        return {
          ...item,
          top: topNextSite.toString(),
          actualTimeTimestamp: actualTime ? actualTime.valueOf() : 0,
          cityTop:
            siteCityObj?.destinationSiteData
              ?.filter((_, index) => index < 3)
              ?.map(
                (item) =>
                  `${item.destinationCity} ${(
                    (item.currentCityCalcWeightSum / item.calcWeightSum) *
                    100
                  ).toFixed(0)}%`,
              )
              ?.join(', ') || '--',
        };
      });
      //#endregion

      yield put({ type: 'updateState', payload: { unloadedList: dataList } });
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
